import styled from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import FontStyles from 'constants/font-styles';
import { applyStyles } from 'util/helpers';
import Colors from 'constants/colors';

const BlockHeader = styled.h3`
  position: relative;

  &:after {
    content: ' ';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 56px;
    border: 0;
    border-top: 1px solid ${Colors.orange1};
    margin-left: 0;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  ${FontStyles.text2};
  padding-bottom: 18px;
  margin: 72px 0 40px;
`;

const spStyle = CustomMedia.lessThan('medium')`
  ${FontStyles.text2};
  padding-bottom: 12px;
  margin: 32px 0 24px;
`;

export default applyStyles(BlockHeader)(pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/common/BlockHeader/index.js